import gql from 'graphql-tag';

export const GetMedicalTestResultListByEncounter = gql`
  query GetMedicalTestResultListByEncounter(
    $testResultDate: Date!
    $source: String!
    $encounterId: ID!
  ) {
    getMedicalTestResultListByEncounter(
      testResultDate: $testResultDate
      source: $source
      encounterId: $encounterId
    ) {
      total
      errors {
        errorCode
        errorDescription
        errors
        requestId
      }
      results {
        dfdEventId
        category
        source
        name
        testDate
        eventId
        isRead
        presentedForm {
          featureType
          contentType
          url
        }
        providerNames
        encounterId
        componentEventIds
      }
    }
  }
`;
